import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationDetailRoute: InvariantJiraRoute = {
	name: 'eoc-integration-detail',
	path: '/jira/settings/products/ops/integrations/:type/:integrationId',
	exact: true,
};
